/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Customer } from '@inyova/models';

import { BehaviorSubject, Observable } from 'rxjs';

import { getCookie, removeCookie, setCookie } from '@shared/utils';
import { environment } from 'src/environments/environment';

interface TokenData {
  accessToken: string;
  client: string;
  expiry: string;
  tokenType: 'Bearer';
  uid: string;
}

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  public tokenData: BehaviorSubject<TokenData> = new BehaviorSubject<TokenData>({
    accessToken: getCookie('accessToken'),
    client: getCookie('client'),
    expiry: getCookie('expiry'),
    uid: getCookie('uid'),
    tokenType: 'Bearer'
  });

  constructor(private http: HttpClient) {}

  validateToken(): Observable<{ status: string; data: Customer }> {
    return this.http.get<{ status: string; data: Customer }>(`${environment.apiUrl}/auth/validate_token`);
  }

  setTokenData(headers, type = 'headers'): void {
    if (!headers) {
      this.removeCookies();
      this.tokenData.next(null);
      return;
    }

    const data: TokenData = {
      accessToken: '',
      client: '',
      expiry: '',
      uid: '',
      tokenType: 'Bearer'
    };

    if (type === 'object') {
      data.accessToken = headers['auth_token'].toString();
      data.client = headers['client_id'].toString();
      data.expiry = headers['expiry'].toString();
      data.uid = headers['uid'].toString();
    } else if (type === '2fa') {
      data.accessToken = '';
      data.client = '';
      data.expiry = '';
      data.uid = '';
    } else {
      data.accessToken = headers.get('Access-token');
      data.client = headers.get('Client');
      data.expiry = headers.get('Expiry');
      data.uid = headers.get('Uid');
    }

    this.tokenData.next(data);
    this.addCookies(data);
  }

  private addCookies({ accessToken, client, expiry, uid }: { accessToken: string; client: string; expiry: string; uid: string }): void {
    setCookie('accessToken', accessToken);
    setCookie('client', client);
    setCookie('expiry', expiry);
    setCookie('uid', uid);
  }

  private removeCookies(): void {
    removeCookie('accessToken');
    removeCookie('client');
    removeCookie('expiry');
    removeCookie('uid');
  }
}
